/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Showroom
 *
 * 1 = Service
 */
export enum LeadBusinessTypeEnum {
  Showroom = 0,
  Service = 1,
}
